import CustomerTraceabilityHistory from "@/components/customer/CustomerTraceabilityHistory";
import Header from "@/components/customer/Header";
import Timesline from "@/components/customer/Timeline";
import Details from "@/components/history/Details";
import CustomerLayout from "@/layouts/CustomerLayout";
import React from "react";
import { useLocation } from "react-router-dom";

const TrackingDetails = () => {
  const { state } = useLocation();
  return (
    <CustomerLayout isWhiteNav={true}>
      <Header />
      <div className="flex md:flex-row flex-column">
        <div className="md:border-right-1 border-gray-400  px-1 col-12 lg:col-7  lg:px-6">
          <Details item={state} />

          <div className="px-2 md:px-4 lg:px-6">
            <Timesline item={state} />
          </div>
        </div>
        <div className="col">
          <h2 className="border-bottom-1 border-gray-400 pb-4 pl-4">
            Data Entry
          </h2>
          <CustomerTraceabilityHistory />
        </div>
      </div>
    </CustomerLayout>
  );
};

export default TrackingDetails;
